import { useHandler } from "@redotech/react-util/hook";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { SettingsPermissions } from "@redotech/redo-model/permissions";
import { OverrideAdjustmentState } from "@redotech/redo-return-ui/flows/return-flow/override-adjustment";
import {
  StepId,
  StepTypeDetailsProps,
} from "@redotech/redo-return-ui/flows/step";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { AdjustmentElement } from "./return";

export const OverrideAdjustmentDetails = memo(
  function OverrideAdjustmentDetails({
    stepSelect,
    state,
    setState,
    flowType,
  }: StepTypeDetailsProps<OverrideAdjustmentState>) {
    const canEditReturnsSettings = useHasPermission(
      SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
    );
    const nextStepChange = useHandler((next: StepId | undefined) => {
      setState((state) => ({ ...state, next }));
    });
    const handleAdjustmentFlat = useHandler((adjustmentFlat: string) => {
      setState((state) => ({ ...state, adjustmentFlat }));
    });
    const handleAdjustmentPercent = useHandler((adjustmentPercent: string) => {
      setState((state) => ({ ...state, adjustmentPercent }));
    });

    return (
      <>
        <AdjustmentElement
          adjustmentFlat={state.adjustmentFlat}
          adjustmentPercent={state.adjustmentPercent}
          canEditReturnsSettings={canEditReturnsSettings}
          handleAdjustmentFlat={handleAdjustmentFlat}
          handleAdjustmentPercent={handleAdjustmentPercent}
        />
        <Text fontSize="xs" textColor="secondary">
          Next step
        </Text>
        {stepSelect({ value: state.next, valueChange: nextStepChange })}
      </>
    );
  },
);
